<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>应付</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form
      :inline="true"
      :model="formInline"
      label-position="right"
      label-width="120px"
      class="searchBar"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="客户名称">
            <el-input
                size="small"
                clearable
                v-model="formInline.customer"
                placeholder="客户名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="承兑人">
            <el-input
                size="small"
                clearable
                v-model="formInline.acceptorName"
                placeholder="承兑人"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="业务经理">
            <el-input
                size="small"
                clearable
                v-model="formInline.inSalesman"
                placeholder="业务经理"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="票号">
            <el-input
                size="small"
                clearable
                v-model="formInline.code"
                placeholder="票号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="日期">
            <el-date-picker
              style="width: 190px !important"
              size="small"
              v-model="formInline.createTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="所在户">
            <el-select
                size="small"
                v-model="formInline.account"
                placeholder="请选择"
            >
              <el-option
                  v-for="type in addTableData"
                  :label="type.value"
                  :value="type.key"
                  :key="type.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-form-item>
            <el-button
              size="small"
              type="primary"
              icon="el-icon-search"
              @click="handleSearch"
              >搜索</el-button
            >
            <el-button
              size="small"
              type="info"
              icon="el-icon-delete"
              @click="handleReset"
              >清空</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>


<!--    <div-->
<!--        style="-->
<!--        width: 100%;-->
<!--        text-align: right;-->
<!--        margin-bottom: 10px;-->
<!--        height: 50px;-->
<!--        line-height: 50px;-->
<!--        float: left;-->
<!--      "-->
<!--    >-->
<!--      <span style="margin-right: 15px">-->
<!--        总应收<span style="font-weight: bold">{{ receivable }}</span>-->
<!--      </span>-->
<!--      <span style="margin-right: 15px">-->
<!--        总应付（万）<span style="font-weight: bold">{{ cope }}</span>-->
<!--      </span>-->
<!--    </div>-->


    <!--列表-->
    <el-table
      size="small"
      :data="userData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
      :span-method="arraySpanMethod"
      :row-style="TableRowStyle"
    >
      <el-table-column align="center" label="操作" width="90">
        <template slot-scope="scope">
<!--          <el-button size="mini" type="primary" v-if="scope.row.receivable > 0" @click="handleEdit(scope.row,99)">收款 </el-button>-->
<!--          <el-button size="mini" type="primary" v-if="scope.row.cope > 0" @click="handleEdit(scope.row,100)">付款</el-button>-->
<!--          <el-button size="mini" type="warning"  @click="handleEditView(scope.row)">编辑</el-button>-->
          <el-button size="mini" type="danger" @click="handleDeleteView(scope.row.id)">删除</el-button>
<!--          <el-button size="mini" type="primary" v-if="scope.row.isChecked == 1" @click="handleRollBackView(scope.row.id)">撤销</el-button>-->
         <!-- <el-button size="mini" type="success" @click="handleDetail(scope.row)">记录 </el-button> -->
        </template>
      </el-table-column>
<!--      <el-table-column-->
<!--          prop="batchTime"-->
<!--          label="批次"-->
<!--          show-overflow-tooltip-->
<!--          align="center"-->
<!--          width="260"-->
<!--      >-->
<!--      </el-table-column>-->
      <el-table-column
          prop="updateTime"
          label="时间"
          show-overflow-tooltip
          align="center"
          width="140px"
      >
      </el-table-column>
      <el-table-column
        prop="code"
        width="90px"
        label="票据号码"
      >
        <template slot-scope="props">
<!--          <el-tooltip effect="dark" :content="props.row.code"  placement="top-start" >-->
            <span>......<span>{{ props.row.code.slice(-9) }}</span></span>
<!--          </el-tooltip>-->
        </template>
      </el-table-column>
      <el-table-column
        prop="customer"
        label="名称"
        show-overflow-tooltip
        align="center"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="account"
        label="所在户"
        show-overflow-tooltip
        align="center"
      >
<!--        <template slot-scope="props">-->
<!--          <el-tooltip effect="dark" :content="props.row.account"  placement="top-start" >-->
<!--            <span>{{ props.row.account}</span>-->
<!--          </el-tooltip>-->
<!--        </template>-->
      </el-table-column>
      <el-table-column
          prop="inSalesman"
          label="业务经理"
          show-overflow-tooltip
          align="center"
          width="180"
      >
      </el-table-column>
      <el-table-column
        prop="acceptorName"
        label="承兑人"
        show-overflow-tooltip
        align="center"
        width="150"
      >
      </el-table-column>
      <el-table-column
          prop="faceValue"
          label="票面金额"
          show-overflow-tooltip
          align="center"
      >
      </el-table-column>
      <el-table-column
          prop="inPercentage"
          label="进价百分比"
          show-overflow-tooltip
          align="center"
      >
      </el-table-column>
      <el-table-column
          prop="inFaceValue"
          label="票面价值"
          show-overflow-tooltip
          align="center"
      >
      </el-table-column>
      <el-table-column
          prop="money"
          label="总值"
          show-overflow-tooltip
          align="center"
          width="100"
      >
        <template slot-scope="props">
          {{
            map.get(props.row.batchTime)
          }}
        </template>
        <!--        {{this.money}}-->
        <!--        <template slot-scope="props">&ndash;&gt;-->
        <!--                    <el-tooltip effect="dark" :content="props.row.account"  placement="top-start" >-->
        <!--                      <span>{{ props.row.account}</span>-->
        <!--                    </el-tooltip>-->
        <!--                  </template>-->
      </el-table-column>

      <el-table-column
          prop="remark"
          label="备注"
          show-overflow-tooltip
          align="center"
          width="260"
      >
        <template slot-scope="props">
          <el-input
              type="textarea"
              rows="1"
              :autosize="{minRows:1,maxRows:8}"
              size="small"
              v-model="props.row.remark"
              auto-complete="off"
              placeholder="备注"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column align="center" label="颜色选中" width="180">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" plain @click="handleEditView(scope.row,'isChecked')">对账</el-button>
          <el-button size="mini" type="success" plain @click="handleEditView(scope.row,'isCleared')">清账 </el-button>
        </template>
      </el-table-column>
    </el-table>
 <!-- 分页组件 -->
    <!-- <Pagination :pager="pager" @pager="handlePager"></Pagination> -->
    <!-- 付款界面 -->
    <EditForm
      :title="title"
      :visible.sync="editFormVisible"
      :edit-form="editForm"
      @confirm="handleEditForm"
    ></EditForm>

    <!-- 编辑界面 -->
    <EditViewForm
        :title="title"
        :visible.sync="editViewVisible"
        :edit-form="editForm"
        @confirm="handleEditForm"
    ></EditViewForm>

<!--    &lt;!&ndash; 详情界面 &ndash;&gt;-->
<!--    <DetailForm-->
<!--        :title="title"-->
<!--        :visible.sync="detailFormVisible"-->
<!--        :edit-form="editRecords"-->
<!--        @confirm="handleEditForm"-->
<!--    ></DetailForm>-->
  </div>
</template>
<style>
/*.el-table__body tr.current-row>td {*/
/*  background: #ffb707!important;*/
/*}*/
/*.el-table--enable-row-hover .el-table__body tr:hover > td {*/
/*  background-color: #ffb707!important*/
/*}*/

.el-table tbody tr:hover>td {
  background-color:transparent !important
}

.el-table__body tr.hover-row.current-row>td, .el-table__body tr.hover-row.el-table__row--striped.current-row>td, .el-table__body tr.hover-row.el-table__row--striped>td, .el-table__body tr.hover-row>td{
  background-color:transparent;
}

.el-table::before{
  background-color: #fff;
}

</style>
<script>
// import Pagination from "@/components/pagination";
import { listTrad,edit } from "@/api/ticket/trad";
// import DetailForm from "./detail";
import EditForm from "./add-edit";
import EditViewForm from "./edit";
import { timestampToDate } from "@/utils";
import { BTN_PERMS_TYPE } from "@/utils/permissions";
import {deleteById, listBussiness, rollback} from "../../../api/ticket/trad";

export default {
  data() {
    return {
      btn_perm_type: BTN_PERMS_TYPE,
      loading: false,
      editFormVisible: false,
      editViewVisible: false,
      detailFormVisible: false,
      title: "",
      editForm: {},
      editRecords: [],
      formInline: {
        customer: "",
        isChecked:0,
        isIn : 1,
        createTime: timestampToDate(new Date()),
      },
      pager: {
        currentPage: 1,
        pageSize: 10,
        total: 1,
      },
      map:new Map(),
      userData: [],
      cope: 0,
      details:[],
      receivable: 0,
      checkType: [
        { key: "出库", value: 1 },
        { key: "入库", value: 0 },
      ],
      addTableData:[
      {"key":"a","value":"    A"},
        {"key":"b","value":"    B"},
        {"key":"c","value":"    C"},
        {"key":"d","value":"    D"},
        {"key":"e","value":"    E"},
        {"key":"f","value":"    F"},
        {"key":"g","value":"    G"},
        {"key":"h","value":"    H"},
      ]
    };
  },
  components: {
    // Pagination,
    // DetailForm,
    EditForm,
    EditViewForm,

  },
  created() {
    this.getData(this.formInline);
  },
  methods: {
    TableRowStyle({ row, rowIndex }) {
      // 注意，这里返回的是一个对象
      let rowBackground = {};
      if (row.isCleared === 1 ) {
        rowBackground.background = "#d9ead3";
        return rowBackground;
      }
      if (row.isChecked === 1 ) {
        rowBackground.background = "#a4c2f4";
        return rowBackground;
      }
    },
    handleFormatDate(row, column, cellValue) {
      if (cellValue) {
        return timestampToDate(cellValue);
      }
      return cellValue;
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {

      if (columnIndex === 10) {
        if(rowIndex ===0 || row.batchTime != this.userData[rowIndex-1].batchTime){
          let money = 0;
          let rowspan = 0;
          this.userData.forEach(element => {
            if(element.batchTime === row.batchTime){
              money = money + (element.inFaceValue * 1000000)
              rowspan ++;
              this.map.set(element.batchTime,money/1000000)
            }
          });
          return [rowspan, 1];
        }else {
          return [0, 0];
        }
      }

      // 合并行  产品名字相同合并
      if (columnIndex === 11) {
        if(rowIndex ===0 || row.batchTime != this.userData[rowIndex-1].batchTime){
          let rowspan = 0;
          this.userData.forEach(element => {
            if(element.batchTime === row.batchTime){
              rowspan ++;
            }
          });
          return [rowspan, 1];
        }else {
          return [0, 0];
        }
      }
       if (columnIndex === 12) {
        if(rowIndex ===0 || row.batchTime != this.userData[rowIndex-1].batchTime){
          let rowspan = 0;
          this.userData.forEach(element => {
            if(element.batchTime === row.batchTime){
              rowspan ++;
            }
          });
          return [rowspan, 1];
        }else {
          return [0, 0];
        }
      }
    },
    handlePager(pager) {
      this.pager.currentPage = pager.currentPage;
      this.pager.pageSize = pager.pageSize;
      this.getData();
    },
    getData() {
      this.editForm = {}
      this.loading = true;
      listTrad(this.pager.currentPage, 10000000,this.formInline)
        .then(({
                 cope,
                 receivable,
                 list,
        }) => {
          // const { content, page, size, totalCount } = pages;
          this.cope = cope;
          this.receivable = receivable;
          this.userData = list;
          // this.pager.currentPage = ;
          // this.pager.pageSize = size;
        })
        .catch(this.$message)
        .finally(() => {
          this.loading = false;
        });
    },
    handleSearch() {
      this.getData();
    },
    handleReset() {
      this.formInline = {
        isIn : 1,
        createTime: timestampToDate(new Date()),
      };
      this.getData();
    },
    handleEditView(row,mes) {
      this.editForm = row;
      if(mes == 'isChecked'){
        this.editForm.isChecked = (row.isChecked - 1);
      }
      if(mes == 'isCleared'){
        this.editForm.isCleared = (row.isCleared - 1);
      }
      edit(this.editForm)
            .then(() => {
              this.$message({
                message: `成功`,
                type: "success",
              });
              this.getData();
            })
            .catch((err) => {
              this.$message({
                message: err.message,
                type: "error",
              });
            });
    },
    handleEdit(row,type) {
      if(99 === type){
        this.title = "收款";
      }else{
        this.title = "付款";
      }

      this.$confirm("修改之后，不可回退，确认修改吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.editForm = row;
        this.editForm.type = type;
        this.editFormVisible = true;
      }).catch(() => {
            this.$message({
              type: "info",
              message: "已取消！",
            });
          });
    },
    handleDetail(row){

console.info(row)
      // listBussiness(row.id)
      //     .then((data) => {
      //       this.title = "交易记录";
      //       this.editRecords = data;
      //       this.detailFormVisible = true;
      //       // this.details = data;
      //       this.detailFormVisible = true;
      //     })
      //     .catch(this.$message.error)
      //     .finally(() => {
      //       this.loading = false;
      //     });

    },
    handleDeleteView(id){
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            deleteById(id)
                .then(() => {
                  this.$message({
                    type: "success",
                    message: "操作成功!",
                  });
                  this.getData();
                })
                .catch(() => {
                  this.$message.error("数据删除失败，请稍后再试！");
                });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除！",
            });
          });
    },
    handleRollBackView(id){
      this.$confirm("确定要撤回吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            rollback(id)
                .then(() => {
                  this.$message({
                    type: "success",
                    message: "操作成功!",
                  });
                  this.getData();
                })
                .catch(() => {
                  this.$message.error("数据删除失败，请稍后再试！");
                });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除！",
            });
          });
    },
    handleEditForm() {
      this.getData();
    },
  },
};
</script>

<style scoped>
.searchBar {
  margin-top: 20px;
  height: 50px;
}
.el-input {
  width: auto !important;
}
</style> 


// WEBPACK FOOTER //
// src/views/ticket/ticket-transaction/index.vue